import Component from './components/Home';
import { PATH } from './constants';

export { PATH };
export default Component;
